var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import { getSchemaModifierStyles } from '../../../contexts/designs/utils';
import { styledWithoutNonHTMLProps } from '../../../theme/utils';
import { SCHEME_MODIFIERS } from '../../../types/Designs.types';
import { propsToNotForward } from './Container.types';
var Container = styledWithoutNonHTMLProps('div', propsToNotForward)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n\n  ", "\n"])), css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), getSchemaModifierStyles(SCHEME_MODIFIERS.default)));
export default Container;
var templateObject_1, templateObject_2;
